import { createApiRef } from '@backstage/core-plugin-api';

/**
 * Secret structure returned from Vault
 */
export interface VaultSecret {
  path: string;
  data: Record<string, any>;
  metadata?: {
    version: number;
    created_time: string;
    deletion_time?: string;
    destroyed?: boolean;
  };
}

/**
 * API for interacting with Vault secrets
 */
export interface VaultSecretsApi {
  /**
   * List secrets at a given path
   */
  listSecrets(path: string): Promise<string[]>;

  /**
   * Read a secret from Vault
   */
  readSecret(path: string): Promise<VaultSecret>;

  /**
   * Write a secret to Vault
   */
  writeSecret(path: string, data: Record<string, any>): Promise<void>;

  /**
   * Delete a secret from Vault
   */
  deleteSecret(path: string): Promise<void>;

  /**
   * Get current user information and Vault auth status
   */
  getUserInfo(): Promise<{
    user: string;
    userEntityRef: string;
    vaultAuthenticated: boolean;
  }>;
}

/**
 * API reference for the Vault secrets API
 */
export const vaultSecretsApiRef = createApiRef<VaultSecretsApi>({
  id: 'plugin.vault-secrets.api',
});